import React, {
    Component
} from 'react';
import {
    domainUrl,
    rootDomainUrl
} from '../config/Config';
import {
    reactLoader,
    getTokenData,
    contentResizeLoad,
    showSmallLeftMenu,
    message,
    scrollToTop,
    ObserverEcoachMessage
} from '../helpers/Common';
import {
    runValidation
} from '../helpers/Validation';
import {
    handleCheckbox,
    handleRadio,
    handleSequence,
    autoFocusNext,
    allowOnlyNumberInput,
    countWords
} from '../helpers/Fields';
import Flowplayer from '../components/Flowplayer';
import Timecountdown from '../components/Timecountdown';
import VoiceRecorder from '../components/VoiceRecorder';
import VirtualKeyboard from '../components/Virtualkeyboard';
import ThanksMessage from './partials/ThanksMessage';
import AssessementViewList from './partials/AssessementViewList';
import SelectLearnerObserver from './partials/SelectLearnerObserver';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getLearningRoom} from '../actions/learningRoomAction';
import Imagezoom from '../components/Imagezoom';
import Confidencemeter from '../components/Confidencemeter';
const $ = window.$;

class Fixedtimetest extends Component {
    constructor(props) {
        super(props);
        this.goToThanksPage = this.goToThanksPage.bind(this);
        this.submitObserverandProceed = this.submitObserverandProceed.bind(this);
        this.sback = this.sback.bind(this);
        this.compeletestatus = "";
        this.state = {
            componentStatus: this.props.data.status,
            observerEvaluation: false,
            evaluationPanel: false,
            testquestions: [],
            testcont: [],
            statusMessages: "",
            testseqfields: [],
            time_left: '',
            time_state: 0,
            is_answered_all: 0,
            resultthank: '',
            isrepeatcomp:'N',
            confidence_meter: '',
        };
    }
    getTestdetails(data) {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + 'normal-test/gettimevariable', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                data
            })
        }).then((response) => response.json()).then((responseJson) => {
            this.setState({
              isrepeatcomp:responseJson.isrepeatcomp, 
                time_left: '',
                testseqfields: {
                    'seconds': responseJson.time_left_seconds,
                    'question_number': responseJson.Mcq_details.question_number
                },
                testcont: responseJson.Mcq_details,
                testquestions: responseJson.McqQuestions,
                is_answered_all: responseJson.Mcq_details.is_answered_all,
                confidence_meter : responseJson.Mcq_details.confidence_meter,
                statusMessage: ObserverEcoachMessage({
                    evaluation_mentor: responseJson.Mcq_details.evaluationMentor,
                    evaluation_ecoach: responseJson.Mcq_details.evaluationEcoach,
                    mentor_perform: responseJson.Mcq_details.mentorPerform,
                    ecoach_perform: responseJson.Mcq_details.ecoachPerform,
                    mentor_view: responseJson.Mcq_details.mentorView,
                    ecoach_view: responseJson.Mcq_details.ecoachView
                })
            });
            setTimeout(() => {
                contentResizeLoad();
                showSmallLeftMenu();
                contentResizeLoad();
                reactLoader("hide");
            }, 200);
            if(this.state.testcont.imagezoom)
			{
				$(function() {
					$('[data-chittizoom]').chittizoom();
				});
			}
        });
    }
    componentDidMount() {
        const {
            data
        } = this.props;
        this.compeletestatus = data.status;
        this.getTestdetails(data);
        setTimeout(() => {
            $('audio').on("play", function(me) {
                $('audio').each(function(i, e) {
                    if (e !== me.currentTarget) {
                        this.pause();
                    }
                });
            });
        }, 500)
    }
    componentWillReceiveProps(nextProps) {
        const {
            data
        } = nextProps;
        this.compeletestatus = data.status;
    }
    backToComponentList() {
        const {
            data
        } = this.props;
        this.props.switchback('component_list', data.learning_room_id, data.dlr_id);
    }
    gotoresult() {
        const {
            data
        } = this.props;
        let sdd = {
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "testresults",
            "look_before": data.compseq_id,
            "flowresult": true
        }
        this.props.switchback(sdd);
    }
    hintopen(question_id, hint_reduce_per, hint_message) {
        const {
            data
        } = this.props;
        window.swal({
            //title: 'Note',
            text: '​Viewing the hint will reduce your score for this question by ' + hint_reduce_per + '%',
            //type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#14a430',
            animation: false,
            cancelButtonColor: '#0082c9',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result) {
                reactLoader("show", "Please wait...");
                fetch(domainUrl + 'normal-test/addhintstatus', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + getTokenData()
                    },
                    body: JSON.stringify({
                        'data': data,
                        'question_id': question_id,
                        'hint_reduce_per': hint_reduce_per
                    })
                }).then((response) => response.json()).then((responseJson) => {
                    if (responseJson.result) {
                        message('Hint!', hint_message, 'info');
                        $('.' + question_id).css('display', 'block');
                    }
                    setTimeout(() => {
                        contentResizeLoad();
                        contentResizeLoad();
                        reactLoader("hide");
                    }, 200);
                });
            }
        });
    }
    getoptions(ans_opt,imagezoomopt) {
        let op_val = '';
        switch (ans_opt.options) {
            case 'image':
                op_val = (imagezoomopt) ? <Imagezoom izsrc={rootDomainUrl+"admin/test_image_files/"+ans_opt.add_on_answer_image} izalt="" izwidth="150" izheight="150"/>: <img src={rootDomainUrl+"admin/test_image_files/"+ans_opt.add_on_answer_image} alt="" width="150" height="150"/>
                break;
            case 'audio':
                op_val = <audio controls controlsList="nodownload">
          <source src={rootDomainUrl+"admin/test_audio_files/"+ans_opt.add_on_answer_audio} type="audio/mpeg" />
        </audio>
                break;
            case 'video':
                op_val = this.video_frame(ans_opt.add_on_answer_video, '');
                break;
            default:
                op_val = <div dangerouslySetInnerHTML={{ __html:ans_opt.options}}></div>
                break;
        }
        return op_val;
    }
    goback(pre_question_id) {
        const {
            data
        } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + 'normal-test/getprevnxtdet', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                'data': data,
                'pre_question_id': pre_question_id
            })
        }).then((response) => response.json()).then((responseJson) => {
            this.setState({
                testcont: responseJson.Mcq_details,
                testquestions: responseJson.McqQuestions
            });
            setTimeout(() => {
                contentResizeLoad();
                showSmallLeftMenu();
                contentResizeLoad();
                reactLoader("hide");
            }, 200);
        });
    }
    submitObserverandProceed(obj) {
        const {
            data
        } = this.props;
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "normal-test/observer-proceed", {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                form_data: this.state.testcont,
                observers: obj,
                data: data
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status == 0) {
                message("OOPS!", "Something went wrong. Please try again later.", "error");
            } else {
				this.props.getLearningRoom();
                scrollToTop();
                // if (responseJson.isCompletedFully) {
                //     this.goToThanksPage();
                // } else {
                    // this.setState({
                    //     componentStatus: "completed"
                    // });
                    this.gotoresult();
                //}
            }
        });
    }

    submittest(cur_question_id) {
      
      let isValid = true;
        if(this.state.confidence_meter==1 && this.state.testcont.allowskip==0)
          {
            if(document.getElementById('notsure_'+cur_question_id).checked === true  || document.getElementById('somewhatsure_'+cur_question_id).checked === true || document.getElementById('verysure_'+cur_question_id).checked === true)
            {
                isValid= true;
            }
            else
            {
                isValid= false;
                $('#errorconfident_'+cur_question_id).css('display','block');
            }
          }

        if (runValidation() && isValid) {
            const {
                data
            } = this.props;
            let formData = new FormData();
            let frmaddobserver = $('#frm_mcq').serializeArray();
            frmaddobserver.map((key, index) => {
                formData.append(key.name, key.value);
            });
            formData.append('compseq_id', data.compseq_id);
            formData.append('learning_room_id', data.learning_room_id);
            formData.append('learner_id', data.learner_id);
            formData.append('dlr_id', data.dlr_id);
            formData.append('is_ag', data.is_ag);
            formData.append('divider_id', data.divider_id);
            formData.append('mcq_questionary_id', data.id);
            formData.append('question_id', cur_question_id);
            formData.append('question_number', this.state.testcont.question_number);
            reactLoader("show", "Please wait...");
            fetch(domainUrl + 'normal-test/savenxt', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: formData
            }).then((response) => response.json()).then((responseJson) => {
                if (responseJson.status === 0) {
                    reactLoader("hide");
                    this.backToComponentList();
                    message(responseJson.message, responseJson.errors, "error");
                } else {
                    this.props.getLearningRoom();
                    scrollToTop();
                    if (responseJson.componentStatus == 'completed') {
                        this.gotoresult();
                    } else if (responseJson.is_answered_all == '1') {
                        let evaluationPanel = (responseJson.componentStatus == "incompleted") ? true : false;
                        this.setState({
                            componentStatus: responseJson.componentStatus,
                            evaluationPanel: evaluationPanel,
                            time_state: 0,
                            is_answered_all: responseJson.is_answered_all
                        });
                    } else {
                        setTimeout(() => {
                            this.goback(responseJson.next_id);
                        }, 200);
                    }
                    reactLoader("hide");
                }
            });
        }
    }

  getquestion(quest_det,ans_opt,i,imagezoomopt){
    let qty_val=[];
    let question_type = quest_det.question_type;
    let classnam = (ans_opt.options=='video') ? "vleft":'fleft';
    switch (question_type) {
      case 1:
        qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
        <span className="flefts"><input type='radio' defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered)>=0} name={quest_det.question_id} onClick={(e)=>handleRadio(e)} value={ans_opt.mcq_answer_id_pk} /></span>
        <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
        </li>
        break;
      case 2:
        qty_val=<li key={`list_${quest_det.question_id}`} className="qleft"><span className="flefts">{i}. </span>
        <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
        </li>;
        break;
      case 3:
        qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
        <span className="flefts"><input type='checkbox' defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered)>=0} name={quest_det.question_id} onClick={(e)=>handleCheckbox(e)} value={ans_opt.mcq_answer_id_pk} /></span>
        <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
        </li>;
        break;
      case 4:
        qty_val=<li key={`list_${quest_det.question_id}`} className="qleft testopt">
        <span className="sfleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
        </li>;
        break;
      case 5:
        qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
        <span className="flefts"><input type='radio' defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered)>=0} name={quest_det.question_id} onClick={(e)=>handleRadio(e)} value={ans_opt.mcq_answer_id_pk} /></span>
        <span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
        </li>;
        break;
      case 8:
          qty_val=<li key={`list_${quest_det.question_id}`} className="qleft"><div data-type="mp3">
          <ul className="btn-ul">
              <li>
                <a id="record" className="button recordButton" >
                <i className="fa fa-microphone"></i>Record</a>
              </li>
              <li>
                <a id="stop" className="button ply-btn"> <i className="fa fa-check"></i> Complete</a>
                <input type="hidden" className="uniquefilecls" name="uniquefile" id="uniquefile"/>
              </li>
              <li className="widht-100">
                <audio className="audio-btm" id="audio" controls=""></audio>
              </li>
            </ul>
            {this.getoptions(ans_opt,imagezoomopt)}
          </div>
          </li>
        break;
      default:
        qty_val='';
      break;
    }
    return qty_val;
  }

  matchfillfun(mk,imagezoomopt){
    let validationClass = (this.state.testcont.allowskip == 0) ? 'required ' : '';
    validationClass = validationClass +'sequence';

    return <li key={`list_${mk.question_id}`} className="qleft">
          <p>Match Set A with correct item in Set B<br />Key in the corresponding no. (1,2,3...) in the box provided</p>
          <div className="tab-match-container">
          <table className="tbl-match">
              <tr className="tbl-match-head">
                <td><b>SET A</b></td>
                <td><b>Correct match from Set B</b></td>
                <td><b>SET B</b></td>
              </tr>
              <tbody>
              {mk.mcq_match_filling.map((mc,r)=>{
                return <tr key={`matches_tr_${r}`} className="tbl-match-body">
                  <td>
                    <div className="statement">
                    {mc.match_ques_type==1 && <center>{mc.match_ques_src}</center>}
                    {mc.match_ques_type==2 && <center>
                        {(imagezoomopt)?
                        <Imagezoom izsrc={rootDomainUrl+'/admin/test_image_files/'+mc.match_ques_src} izalt="" izwidth="200" izheight="200" />
                        :
                        <img src={rootDomainUrl+'/admin/test_image_files/'+mc.match_ques_src} alt="" width="200" height="200" />
                        }
                        </center>}
                    {mc.match_ques_type==3 && <audio controls controlsList="nodownload">
                      <source src={rootDomainUrl+"admin/test_audio_files/"+mc.match_ques_src} type="audio/mpeg" />
                      </audio>
                    }
                    {mc.match_ques_type==4 && this.video_frame(mc.match_ques_src, '') }
                    </div>
                  </td>
                  <td>
                    <input type="text" name={mk.question_id} className="txtbox matchtxt auto-focus" style={{width: "40px"}} title="Enter numeric input" maxLength="2" onKeyPress={e=>allowOnlyNumberInput(e)} onKeyUp={(e)=>autoFocusNext(e, 'tr')} onBlur={(e)=>handleSequence(e)} defaultValue={mk.answered[r]}/>
                  </td>
                  <td>
                    <div>
                        <span style={{float: "left"}}>{r+1}. </span>
                        <div className="statement">
                        {mc.match_ans_type==1 && <center>{mc.match_ans_src}</center>}
                        {mc.match_ans_type==2 && <center>
                            {(imagezoomopt)?
                            <Imagezoom izsrc={rootDomainUrl+'/admin/test_image_files/'+mc.match_ans_src} izalt="" izwidth="200" izheight="200" />
                            :
                            <img src={rootDomainUrl+'/admin/test_image_files/'+mc.match_ans_src} alt="" width="200" height="200" />
                            }
                            </center>}
                        {mc.match_ans_type==3 && <audio controls controlsList="nodownload"><source src={rootDomainUrl+"admin/test_audio_files/"+mc.match_ans_src} type="audio/mpeg" /></audio>
                        }
                        {mc.match_ans_type==4 && this.video_frame(mc.match_ans_src, '') }
                        </div>
                    </div>
                  </td>
                </tr>
              })}
            </tbody>
          </table>
          <input type="hidden" name={`${mk.question_id}_hidden`} className={validationClass} data-max-seq={mk.mcq_match_filling.length} defaultValue={mk.fullanswer} />
        </div>
      </li>
  }

  video_frame(video_files, text) {

    const { data } = this.props;
    let trackData={

        compseq_id: data.compseq_id,
        lroom_id: data.learning_room_id,
        divider_id: data.divider_id,
        learner_id: data.learner_id,        
        dlr_id: data.dlr_id,
        compo_type:data.compo_type
    };

    let playlist={
        share:false,
        ratio: 9/16,
        clip:{
          sources: [
                  {
                   
                    type: "video/mp4",
                    src: rootDomainUrl+'admin/test_video_files/'+video_files
                  }
                 ]
        }
    };
   
    return <Flowplayer playlist={playlist} trackData={trackData} />;
  }

  openendquestions(mk){
    let validationClass = (this.state.testcont.allowskip == 0) ? 'required ' : '';
    validationClass = validationClass +'textbox_big word-count-check';

    return <li key={`list_${mk.question_id}`}>
    <span className="textbox_align1">
      {/* <textarea name={mk.question_id} className={validationClass} cols="70" rows="7" onKeyUp={(e)=>countWords(e)} data-total-words={mk.openended_maxwords}>{mk.fullanswer}</textarea> */}
      {(mk.is_virtualkeyboard==1) ? <VirtualKeyboard qus_id={mk.question_id} validate={validationClass} chkonkeyup={(e)=>countWords(e)} data_maxword={mk.openended_maxwords}  /> : <textarea name={mk.question_id} id={`keyboard${mk.question_id}`} className={validationClass} rows="3" style={{height: "inherit", resize: "none"}} onKeyUp={(e)=>countWords(e)} data-total-words={mk.openended_maxwords}></textarea>}
      <div className="max-words">
      <span className="date_red lefttxt">
      Max words: {mk.openended_maxwords}
      </span>
      </div>
      <div className="word-count">
      <span className="balance-words"></span>
      <span className="typing-words"></span>
      </div>
    </span>
    </li>
  }

  sback(sdata){
    if(sdata.componentStatus=='completed'){
      this.gotoresult();
    } else {
      let evaluationPanel = (sdata.componentStatus == "incompleted") ? true : false;
      this.setState({
        componentStatus: sdata.componentStatus,
        evaluationPanel: evaluationPanel,
        time_state:0,
        is_answered_all: sdata.is_answered_all
      });
    }
    //const {data}=this.props;
    //this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
  }

  continueToComplete() {
    this.setState({ evaluationPanel: true });
  }

  opentest(){
    const {data}=this.props;
    reactLoader("show", "Please wait...");
    this.setState({time_state:1});
    let vdf = this.state.testseqfields;
    this.setState({time_left: <Timecountdown seconds={vdf.seconds} details={data} question_number={vdf.question_number} state={this.state.time_state} tfs={this.sback} goToThanksPage={this.goToThanksPage}/>});
    setTimeout(()=>{
      reactLoader("hide");
    }, 1000);

  }

  goToThanksPage() {
      const {
          data
      } = this.props;
      this.props.returnthanks({
          "status": "completed",
          "learning_room_id": data.learning_room_id,
          "compseq_id": data.compseq_id,
          "divider_id": data.divider_id,
          "dlr_id": data.dlr_id,
          "learner_id": data.learner_id,
          "is_ag": data.is_ag,
          "id": data.id,
          "compo_type": "thanks",
          "look_before": data.compseq_id,
          "flowresult": true
      });
  }

  submitObserverandProceed(obj) {
    const {data} = this.props;

    reactLoader("show", "Please wait...");
    fetch(domainUrl +"normal-test/observer-proceed", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization':'Bearer ' +getTokenData()
      },
      body: JSON.stringify({
        form_data: this.state.testcont,
        observers: obj,
        data: data
      })
    }).then((response) => response.json()).then((responseJson) => {
      reactLoader("hide");
      if (responseJson.status == 0) {
        message("OOPS!", "Something went wrong. Please try again later.", "error");
      }else {
        this.setState({ componentStatus: "completed" });
        this.gotoresult();
      }
    });
  }

  render() {
    let data=this.state.testcont;
    let testquestions=this.state.testquestions;
    let index=1;
    let control_style={ width:'50%'};
    let seq_op=[];
    let optionText = [], vcla = (testquestions.is_hint_viewed>0) ? 'block':'none';
    let cur_question_id= testquestions.question_id;
    let pre_question_id= data.pre_question_id;
    let answered = testquestions.answered;
    let checkboxRadioClass = (data.allowskip == 0) ? 'required ' : '',
        sequenceClass = (data.allowskip == 0) ? 'required ' : '',
        optionClass = (data.allowskip == 0) ? 'required ' : '';

    checkboxRadioClass = checkboxRadioClass +'max-select-check';
		sequenceClass = sequenceClass +'sequence';
		optionClass = optionClass +'with-in-options txtbox fillupstxt';
    let confidence_meter=this.state.confidence_meter;
    return (
      <div className="main-inner">
        <div className="border-box">
        <div className={data.base_line?"title-box":"title-box tit-new"}>
            <div title="Videocomponents" className="ts_active_button"></div>
              <h6>{data.mcq_name?data.mcq_name:''}</h6>
              <span className="bluetxt">{data.base_line?data.base_line:''}</span>
            </div>

            {data.learner_msg !== "" && this.state.is_answered_all!=1 &&  
            <div style={{ float: "left", padding: "10px 0px 10px 0px", marginLeft: "25px" }}><div className="editortxt">
                <span dangerouslySetInnerHTML={{ __html: data.learner_msg ? data.learner_msg : '' }} />
            </div></div>
            }


            <section className="scrol" id="smana-scroll-inner">
              <section className="viewport">
                <section className="overview">
                  <div className="inner-content">
                    { this.state.componentStatus === "incompleted" && this.state.is_answered_all=='1' && this.state.evaluationPanel &&
                        <div className="custom-react-wrapper">
                            <ThanksMessage message={this.state.statusMessage} />
                            <SelectLearnerObserver submitObserverandProceed={this.submitObserverandProceed} />
                        </div>
                    }

                    { this.state.is_answered_all!=1 && this.state.time_state==0 &&
                     <div>
                     {this.state.isrepeatcomp=='Y' && <div style={{ float: "left", padding: "10px 0px 10px 0px", marginLeft: "25px" }}>
                     <div className="editortxtbx">
                     <span><b>Message:</b> You can repeat this test after completion. However, the score achieved in your first attempt will be your final score.</span> 
                     </div>
                     </div>
                     }
                      <div className="testtimedeg">
                        <div className="ftime_contbg">
                          <div className="time-allot-img">
                            <img src={process.env.PUBLIC_URL +"/images/timer.gif"} width="74" border="0" height="74" />
                          </div>
                           <div className="time-cont-txt">
                            <div className="time-cont-box">
                              Questions completed: <b className="txt-green">{data.question_completed}</b>
                              <br />Time taken: <b className="txt-green">{data.time_left_mintues_string}<span className="normaltxt"> mins</span> {data.time_left_seconds_string}<span className="normaltxt"> secs</span></b>
                            </div>
                            <div className="time-align">Time Alloted:<br /> <b className="txt-red">{data.time_duration} mins</b></div>
                            <div className="time-divider"><img src={process.env.PUBLIC_URL +'/images/divider.gif'} width="1" height="54" border="0" /></div>
                          </div>
                        </div>
                        <div className="right">
                          <input name="btnroom" title="Continue" type="button" className="Btgoback" value="Continue" onClick={(e)=>this.opentest()}/>
                        </div>
                      </div>
                      </div>
                    }
                    {this.state.is_answered_all!=1 && this.state.time_left}

                    { this.state.time_state!=0 && this.state.is_answered_all!=1 &&
                      <form name="frm_mcq" id="frm_mcq" key={`FTa${cur_question_id}`}>
                      <div key={`aT${cur_question_id}`}>
                        <div key={`Ta${cur_question_id}`} className="lr-gray-box test">
                          <div className="graybox_border" key={`gTa${cur_question_id}`}>
                              {(testquestions.hint_for_learner!='' && testquestions.hint_for_learner!=undefined) &&
                              <div key={`hint${cur_question_id}`} className="test-hint">
                              <a href="javascript:void(0);" onClick={e=>this.hintopen(testquestions.question_id,testquestions.hint_reduce_per,testquestions.hint_for_learner)} title={`​Viewing the hint will reduce your score for this question by ${testquestions.hint_reduce_per}%`}>Hint</a>
                              <div style={{display:vcla}} key={`hv${index}`} className={`hint-viewed ${testquestions.question_id}`} title="You have already viewed hint for this question">Viewed</div>
                              </div>
                              }
                              <span className="blwetxt" style={{ float: "left" }}>Q{data.question_number}. </span>
                              <span className="quetn" dangerouslySetInnerHTML={{ __html:testquestions.mcq_question_name}} />
                              { (testquestions.question_images!=undefined) && testquestions.question_images.map((val,index)=>{
                                  if(val!='' && val!=undefined){
                                    return <div key={`imageq${index}`} className="qleft">
                                    {(data.imagezoom)?
                                    <Imagezoom izsrc={rootDomainUrl+"admin/test_image_files/"+val} izalt="" izwidth={testquestions.img_width} izheight={testquestions.img_height}/>
                                    :
                                    <img src={rootDomainUrl+"admin/test_image_files/"+val} alt="" width={testquestions.img_width} height={testquestions.img_height}/>
                                    }
                                    </div>
                                  }
                                })
                              }
                              { (testquestions.question_audio!=undefined) && testquestions.question_audio.map((aval,aindex)=>{
                                if(aval!='' && aval!=undefined){
                                return <div key={`auq${index}`} className="qleft"><audio controls controlsList="nodownload">
                                    <source src={rootDomainUrl+"admin/test_audio_files/"+aval} type="audio/mpeg" />
                                  </audio></div>
                                }
                              })}

                              { (testquestions.question_video!=undefined) && testquestions.question_video.map((vval,vindex)=>{
                                if(vval!='' && vval!=undefined){
                                  return this.video_frame(vval, '');
                                }
                              })}

                              <div className="test-ques">
                                <div className="ans-select">
                                  <ul key={`aopt${index}`}>
                                    {testquestions.question_type==4 && <span className=""><b>your options are: </b></span> }

                                    { (testquestions.question_option_answers!=undefined) && testquestions.question_option_answers.map((qas,i)=>{
                                      if (testquestions.question_type==4) {
                                        optionText.push(qas.options);
                                      } else if (testquestions.question_type==2) {
                                        seq_op.push(<span className="seq-container"><input type="text" name={`${testquestions.question_id}`} className="seq_txtbox auto-focus" maxLength="2" onKeyPress={e=>allowOnlyNumberInput(e)} onKeyUp={(e)=>autoFocusNext(e, '.seq-container')} onBlur={(e)=>handleSequence(e)} defaultValue={qas.inserted_answer!=undefined ? qas.inserted_answer:''}/> -</span>);
                                      }
                                      return this.getquestion(testquestions,qas,i+1,data.imagezoom);
                                    })}

                                    {(testquestions.question_type==6) && this.openendquestions(testquestions)}

                                    {(testquestions.question_type==7 && (testquestions.mcq_match_filling!=undefined)) && this.matchfillfun(testquestions,data.imagezoom)}

                                    {$.inArray(testquestions.question_type, [1,3,5]) >= 0 &&
                                      <input type="hidden" name={`${testquestions.question_id}_hidden`} className={checkboxRadioClass} data-max-option={testquestions.max_multiple} defaultValue={testquestions.fullanswer}/>
                                    }
                                  </ul>
                                  { testquestions.question_type==8 && <VoiceRecorder questionData={testquestions} /> }

                                  { testquestions.question_type==2 && <div>{seq_op}
                                    <span className="integratestsmalltxt">(Eg: 4 - 3 - 1 - 2.)</span>
                                    <div><input type="hidden" name={`${testquestions.question_id}_hidden`} className={sequenceClass} data-max-seq={testquestions.question_option_answers.length} defaultValue={testquestions.fullanswer} /></div>
                                    </div>
                                  }
                                  { testquestions.question_type==4 && <span className="integratestsmalltxt">
                                    Ans:<input type="text" name={testquestions.question_id} className={optionClass} data-options={optionText.join(',')} defaultValue={testquestions.answered}/>
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                            {confidence_meter==1 ? <Confidencemeter dynamic_confidence={testquestions.question_id}/> : ''}
                          </div>
                          <div id="InActive" className="button bkbtn">
                            <input value="Next" className="Btgoback" type="button" onClick={(e)=>this.submittest(cur_question_id)}/>
                            {data.question_number>1 && data.allowgoback >0 &&
                              <input name="Btgoback" value="Go Back" className="Btgoback" type="button" onClick={(e)=>this.goback(pre_question_id)} />
                            }
                          </div>
                        </div>
                      </form>
                    }

                    { this.state.componentStatus === "incompleted" && this.state.is_answered_all=='1' && !this.state.evaluationPanel &&
                      <div className="custom-react-wrapper">
                          <div className="ratebox">You have already answered this component.<br />This component will get completed only when you choose Observer(s) to rate your answers.</div>
                          <div style={{textAlign: "right"}}>
                              <input type="button" className="button_org" value="Continue" title="Continue" onClick={()=>this.continueToComplete()} />
                          </div>
                      </div>
                    }

                  </div>
                </section>
              </section>
            </section>
          </div>
        </div>
      );
  }
}

function mapDispatchToProps(dispatch) {

    return  bindActionCreators({getLearningRoom}, dispatch);

}

export default connect(null,mapDispatchToProps)(Fixedtimetest);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Fixedtimetest.js